import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import PageContainer from "./layout/PageContainer.js";
import JsonLd from "./JsonLd.js";
import GuideCoverHero from "./guide/GuideCoverHero.js";
import GuideTableOfContents from "./guide/GuideTableOfContents.js";
import { MENTAL_NOISE_GUIDE } from "../constants/mentalNoiseGuide.js";
import { MENTAL_NOISE_COVER } from "../constants/mentalNoiseGuideVisuals.js";
import { buildGuideJsonLd } from "../utils/guideJsonLd.js";
import "../mental-clarity-guide.css";

const DEFAULT_TITLE = "Ahavibes — Stop reacting. Start thinking clearly.";
const DEFAULT_DESCRIPTION =
  "A guided framework to examine interpretations, reduce mental noise, and make better decisions.";
const PAGE_TITLE = "The Complete Guide to Mental Noise | Ahavibes";

const MentalNoise = () => {
  const jsonLd = useMemo(() => buildGuideJsonLd(MENTAL_NOISE_GUIDE), []);

  useEffect(() => {
    document.title = PAGE_TITLE;

    let meta = document.querySelector('meta[name="description"]');
    const createdMeta = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const previousDescription = meta.getAttribute("content");
    meta.setAttribute("content", MENTAL_NOISE_GUIDE.description);

    return () => {
      document.title = DEFAULT_TITLE;
      if (createdMeta) {
        meta.remove();
      } else {
        meta.setAttribute("content", previousDescription || DEFAULT_DESCRIPTION);
      }
    };
  }, []);

  return (
    <>
      <JsonLd data={jsonLd} id="mental-noise-jsonld" />
      <PageContainer size="wide" className="mental-clarity-guide">
        <GuideCoverHero
          headline={MENTAL_NOISE_GUIDE.headline}
          lead={MENTAL_NOISE_GUIDE.description}
          cover={MENTAL_NOISE_COVER}
        />
        <GuideTableOfContents sections={MENTAL_NOISE_GUIDE.sections} basePath="/mental-noise" />
        <nav className="guide-section-nav" aria-label="Pillar navigation">
          <div className="guide-section-nav__links">
            <Link to="/mental-clarity" className="guide-section-nav__link guide-section-nav__link--prev">
              &larr; Previous: Mental Clarity
            </Link>
            <Link to="/structured-thinking" className="guide-section-nav__link guide-section-nav__link--next">
              Next: Structured Thinking &rarr;
            </Link>
          </div>
        </nav>
      </PageContainer>
    </>
  );
};

export default MentalNoise;
